module.exports = __webpack_public_path__ + "static/media/icon_88.65c85c18.svg";